import { Link } from 'react-router-dom';
import './LegalPage.css';

export default function TermsOfServicePage() {
  return (
    <section className="legal-page" aria-labelledby="terms-heading">
      <div className="legal-inner">
        <h1 id="terms-heading">Terms of Service</h1>
        <p className="legal-updated">Last updated: 8 August 2026</p>

        <p>
          These terms govern your use of SnapScrap, including posting scrap, becoming a collector,
          and contacting our team. By using the site, you agree to these terms.
        </p>

        <h2>Our service</h2>
        <p>
          SnapScrap helps people post scrap for collection and helps licensed collectors find local
          jobs. We provide the platform connection — collectors remain responsible for lawful
          collection, transport, and disposal/recycling of scrap metal.
        </p>

        <h2>Your responsibilities</h2>
        <ul>
          <li>Provide accurate listing, contact, and location information</li>
          <li>Only post scrap you have the right to dispose of</li>
          <li>Collectors must hold valid licences and insurance where required</li>
          <li>Do not misuse the platform for illegal dumping or fraudulent activity</li>
        </ul>

        <h2>Accounts and communication</h2>
        <p>
          You agree that SnapScrap may contact you about listings, collector matching, safety
          checks, and service updates using the details you provide.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          SnapScrap is not liable for disputes between posters and collectors, scrap valuation
          differences, or third-party delays, except where required by law.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these terms from time to time. Continued use of SnapScrap after changes
          means you accept the updated terms.
        </p>

        <h2>Contact</h2>
        <p>
          For questions, visit our <Link to="/contact">Contact</Link> page or email{' '}
          <a href="mailto:cs@snapscrap.co.uk">cs@snapscrap.co.uk</a>.
        </p>
      </div>
    </section>
  );
}
